import { Button, HStack, InvertTheme, Menu, MenuItems } from '@stoplight/mosaic';
import { useContext, useMemo } from 'react';
import constants from '../constants';
import { GlobalContext } from '../context';


export const Navigation = () => {
  const { apiDescriptionUrl } = useContext(GlobalContext);

  const renderPicker = () => {
    if (constants.specs.length < 2)
      return;

    if (constants.invertHeaderColor) {
      return (
        <InvertTheme>
          <HStack w="1/3" flex={1} justifyContent="end" px={5}>
            <WebServicePicker />
          </HStack>
        </InvertTheme>
      )
    }

    return (
      <HStack w="1/3" flex={1} justifyContent="end" px={5}>
        <WebServicePicker />
      </HStack>
    )
  }

  const renderTitle = () => {
    var title = "";
    if (constants.title)
      title = constants.title + " ";
    if (constants.appendSpecTitleInTitleArea) {
      let spec = constants.specs.find(o => o.value === apiDescriptionUrl);
      title = title + spec?.text;
    }

    if (!title)
      return;

    return (
      <span style={{ color: constants.invertHeaderColor ? 'black' : 'white', marginRight: '5px', fontWeight: 'bold' }} id="nav-bar">
        {title}
      </span>
    );
  }

  const getMainUrl = () => {
    if (constants.getMainUrl)
      return constants.getMainUrl();
    return "/";
  }

  return (
    <nav className="topnav" style={{ backgroundColor: constants.backgroundColor }}>
      {constants.logoBase64 && (
        <a href={getMainUrl()}>
          <img src={constants.logoBase64} />
        </a>
      )}
      {renderTitle()}
      {renderPicker()}
    </nav>
  );
};

const WebServicePicker = () => {
  const { apiDescriptionUrl, setDescriptionUrl } = useContext(GlobalContext);

  const menuItems = useMemo(() => {
    const items: MenuItems = [
      {
        type: 'option_group',
        value: apiDescriptionUrl,
        onChange: setDescriptionUrl,
        children: constants.specs.map(s => ({
          title: s.text,
          value: s.value,
        })),
      },
    ];

    return items;
  }, [apiDescriptionUrl, setDescriptionUrl]);

  let spec = constants.specs.find(o => o.value === apiDescriptionUrl);
  return (
    <Menu
      closeOnPress
      aria-label="انتخاب وب سرویس"
      items={menuItems}
      renderTrigger={({ isOpen }) => (
        <Button iconRight={['fas', 'caret-down']} active={isOpen}>
          {spec?.text || "انتخاب وب سرویس"}
        </Button>
      )}
    />
  );
};
